import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDButton from "components/MDButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ContractContext } from "context/contract";
import { useMaterialUIController } from "context";


import { EVENT_STATUS } from "../utils/eventStatus";
import { track } from "utils/track";

export default function EventCard({ event, onEdit, onCancel, client }) {

  const status = EVENT_STATUS[event.status] || EVENT_STATUS.draft;
  const eventClient = client?.find(c => c.id === event.client_id);

  const navigate = useNavigate();
  const { getByEvent } = useContext(ContractContext);
  
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Verificar se existe contrato SEM fazer requisições (usar dados já carregados)
  const contract = getByEvent(event.id);


  return (
    <MDBox
      p={3}
      mb={2}
      borderRadius="xl"
      bgColor={darkMode ? "dark" : "white"}
      shadow="md"
    >
      {/* Header */}
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography fontWeight="bold" mr={2}>
          {event.title}
        </MDTypography>

        <MDBadge
          badgeContent={status.label}
          color={status.color}
          variant="gradient"
        />
        
      </MDBox>

      {/* Info */}
      <MDBox mt={1}>
        <MDTypography variant="caption"  mr={2}>
        📅 {event.event_date ? event.event_date.split("T")[0].split("-").reverse().join("/") : ""}
          {event.start_time && ` • ⏰ ${event.start_time}`}
        </MDTypography>

         {eventClient && (
          <>
            <MDTypography variant="caption"  mr={2}>
              👤 {eventClient.name}
            </MDTypography>

            {eventClient.phone && (
              <MDTypography variant="caption" mr={2}>
                📞 {eventClient.phone}
              </MDTypography>
            )}
          </>
        )}

        {(event.location || event.city || event.address?.city) && (
          <MDTypography variant="caption" mr={2}>
            📍 {[event.location, event.city || event.address?.city].filter(Boolean).join(" - ")}
          </MDTypography>
        )}

        <MDTypography variant="caption"  mr={2}>
          🎧 {event.event_type}
        </MDTypography>

        {event.price && (
          <MDTypography variant="caption" mr={2}>
            💰 R$ {Number(event.price).toFixed(2)}
          </MDTypography>
        )}
      </MDBox>

      {/* Actions */}
      <MDBox mt={2} display="flex" gap={1} flexWrap={isMobile ? "wrap" : "nowrap"} alignItems="center">

        <MDButton
          size="small"
          variant="contained"
          color="success"
          onClick={() => {
             if (eventClient?.phone) {
               track("dj_contato_cliente", { origem_contato: "eventos" });
               window.open(`https://wa.me/55${eventClient.phone.replace(/\D/g, "")}`, "_blank");
             }
          }}
          disabled={!eventClient?.phone}
          sx={{ 
            order: isMobile ? 4 : 0, 
            width: isMobile ? "100%" : "auto", 
            justifyContent: "center",
            display: "flex",
            alignItems: "center"
          }}
        >
          <WhatsAppIcon sx={{ mr: 0.5 }} />
          WhatsApp
        </MDButton>

        <MDButton
          size="small"
          color={contract ? "success" : sidenavColor}
          variant="outlined"
          onClick={() => navigate(`/contracts/event/${event.id}`)}
          sx={{ order: 1, flexGrow: isMobile ? 1 : 0 }}
        >
          {contract ? "Ver contrato" : "Gerar contrato"}
        </MDButton>

        <MDButton
          size="small"
          color={sidenavColor}
          variant="outlined"
          onClick={() => onEdit(event)}
          sx={{ order: 2, flexGrow: isMobile ? 1 : 0 }}
        >
          {event.status === 'cancelled' ? "Ver / Restaurar" : "Editar"}
        </MDButton>

        {event.status !== "cancelled" && (
          <MDButton
            size="small"
            variant="outlined"
            color="error"
            onClick={() => onCancel(event)}
            sx={{ order: 3, flexGrow: isMobile ? 1 : 0 }}
          >
            {isMobile ? "Cancelar" : "Cancelar Evento"}
          </MDButton>
        )}
      </MDBox>
    </MDBox>
  );
}
